import { CSSProperties } from 'react';

export const glassTooltipContentStyle: CSSProperties = {
  backgroundColor: 'rgba(255, 255, 255, 0.78)',
  border: '1px solid rgba(148, 163, 184, 0)',
  borderRadius: 12,
  boxShadow: '0 12px 30px rgba(15, 23, 42, 0.22)',
  backdropFilter: 'blur(8px) saturate(145%)',
  WebkitBackdropFilter: 'blur(8px) saturate(145%)',
};

export const glassTooltipLabelStyle: CSSProperties = {
  color: '#0f172a',
  fontWeight: 700,
};

export const glassTooltipItemStyle: CSSProperties = {
  fontWeight: 700,
};
